
































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import BaseComponent from '@/components/base-component.vue';
import UiAutocompleClientsSubsidiaries from '@/components/UI/autocomplete-clients-subsidiaries.vue';
import UiSelectDoctor from '@/components/UI/select-doctors.vue';
import * as serviceDoctor from '@/services/doctors';
import { getTeamsByClient } from '@/services/teams';
import IDoctor from '@/interfaces/doctor';
import {
  REFERENCE_TYPE_CLIENT,
  REFERENCE_TYPE_DOCTOR,
  REFERENCE_TYPE_TEAM,
} from '@/settings/consts/rules-engine';
import RuleModel from '@/models/rule-model';
import ParameterModel from '@/models/parameter-model';
import { getParameters } from '@/services/parameters';

@Component({
  components: { UiAutocompleClientsSubsidiaries, UiSelectDoctor },
})
export default class ParametersOverrideFilterList extends BaseComponent {
  get referencesTypesList(): any[] {
    const types = [];

    if (this.inHierarchyLevels(REFERENCE_TYPE_CLIENT)) {
      types.push({
        id: REFERENCE_TYPE_CLIENT,
        label: 'Unidade',
      });
    }

    if (this.inHierarchyLevels(REFERENCE_TYPE_TEAM)) {
      types.push({
        id: REFERENCE_TYPE_TEAM,
        label: 'Time',
      });
    }

    if (this.inHierarchyLevels(REFERENCE_TYPE_DOCTOR)) {
      types.push({
        id: REFERENCE_TYPE_DOCTOR,
        label: 'Médico',
      });
    }

    return types;
  }
  @Prop(ParameterModel)
  public parameter: ParameterModel;

  public filter: any = {
    parameter: null,
    referenceType: null,
    clientUnit: null,
    doctor: null,
    team: null,
  };

  public selectedClient: any = {};

  public referencesTypes: any = {
    client: REFERENCE_TYPE_CLIENT,
    team: REFERENCE_TYPE_TEAM,
    doctor: REFERENCE_TYPE_DOCTOR,
  };

  public doctors: IDoctor[] = [];
  public teams: any[] = [];
  public parameters: ParameterModel[] = [];
  public doctorsLoading: boolean = false;
  public teamsLoading: boolean = false;
  public parametersLoading: boolean = false;

  @Watch('parameter')
  public onParameterChange(val: ParameterModel): void {
    if (!!val) {
      this.filter.parameter = val;
    }
  }

  public beforeMount(): void {
    this.filter.referenceType = REFERENCE_TYPE_CLIENT;
    this.getParameters();
    this.getDoctors();
  }

  public onChangeClientTeam(): void {
    if (!this.selectedClient || !this.selectedClient.id) {
      return;
    }
    this.getTeams(this.selectedClient.id);
  }

  public onChangeFilterReference(): void {
    this.filter.clientUnit = null;
    this.filter.doctor = null;
    this.filter.team = null;
    this.onFilter();
  }

  public onFilter(): void {
    this.$emit('filter', this.filter);
  }

  private inHierarchyLevels(reference: string): boolean {
    const notFound = -1;
    return (
      !this.filter.parameter ||
      !this.filter.parameter.hierarquiasPossiveis.length ||
      this.filter.parameter.hierarquiasPossiveis.indexOf(reference) !== notFound
    );
  }

  private getParameters(): void {
    this.parametersLoading = true;
    getParameters().subscribe(
      (data) => {
        this.parameters = data.map((item) => new ParameterModel(item));
        this.parametersLoading = false;
      },
      () => {
        this.parametersLoading = false;
      },
    );
  }

  private getTeams(clientUnitId: string): void {
    this.teams = [];
    if (!clientUnitId) {
      return;
    }
    this.teamsLoading = true;

    getTeamsByClient(clientUnitId).subscribe(
      (data) => {
        this.teams = data;
        this.teamsLoading = false;
      },
      () => {
        this.teamsLoading = false;
      },
    );
  }

  private getDoctors(): void {
    this.doctors = [];
    this.doctorsLoading = true;

    serviceDoctor.getDoctors().subscribe(
      (data) => {
        this.doctors = data;
        this.doctorsLoading = false;
      },
      () => {
        this.doctorsLoading = false;
      },
    );
  }
}
